/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React, { useEffect, useState } from "react";

/* COMPONENTES PROPIOS */
import MsgResultatQuery from "../../components/PantallesBKI/MsgResultatQuery/MsgResultatQuery";
import { ToolbarLogsEnviaments } from "../../components/PantallesBKI/DataGridMui/CustomToolbar/CustomToolbar";

import DataGridBkitb from "../../components/PantallesBKI/DataGridMui/DataGrid";
import {
  columnsTrazabilidad,
  columnsTraceServeis,
} from "../../components/PantallesBKI/DataGridMui/Columns/Columns";
import { SERVEI_TO_APP } from "../../constants/serveiToApp";
import { URL_BKI, APP_JSON, URL_BKINT_TRAM } from "../../constants/URL";

/* COMPONENTES MUI */
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

/* ICONOS */
import UndoIcon from "@mui/icons-material/Undo";

/*MENSAJES DE ALERTA*/
import { Container, Grid, Paper, Stack, Typography } from "@mui/material";
import TraceFilterBox from "../../components/PantallesBKI/trazabilidad/TraceFilterBox";
import { useTraceFiltersContext } from "../../contexts/trazabilidad/TraceFiltersContext";
import fetchData from "../../libs/client/httpClient";
import ErrorAlert from "../../components/PantallesBKI/Alertas/ErrorAlert";

//Estilos MODAL
const styleModal = {
  position: "fixed",
  top: "50%",
  textAlign: "center",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  maxWidth: "800px",
  maxHeight: "80%",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
};
const styleModalSenseResultats = {
  position: "absolute",
  top: "40%",
  textAlign: "center",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Trazabilidad() {
  const [data, setData] = useState([]);
  const [dataTraza, setDataTraza] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [loading, setLoading] = useState(false);

  const { filters } = useTraceFiltersContext();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSelectionModel([]);
    setSelectedRow(null);
    setDataTraza(null);
  };

  const fetchTrace = (trazaID) => {
    setLoading(true);
    fetch(URL_BKI.TRACE + trazaID, {
      headers: {
        "Content-Type": APP_JSON,
        Accept: APP_JSON,
      },
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        setLoading(false);
        setDataTraza(myJson);
      })
      .catch((error) => {
        console.error(
          `Ha ocurrido un error al pedir el recurso. Error: ${error.message}`
        );
        setLoading(true);
      });
  };

  const fetchTraces = async () => {
    setLoading(true);

    // Si hay filtro de App, obtener los códigos SERVEI asociados
    const appSeleccionada = filters && filters.app; // Ajusta el nombre según la estructura de filtros
    if (appSeleccionada) {
      // Obtener todos los códigos SERVEI para la App seleccionada
      const codigosServei = Object.entries(SERVEI_TO_APP)
        .filter(([servei, app]) => app === appSeleccionada)
        .map(([servei]) => servei);

      // Hacer una petición por cada SERVEI y combinar los resultados
      const peticiones = codigosServei.map(servei => {
        const filtrosConServei = { ...filters, servei };
        delete filtrosConServei.app; // Elimina el filtro app para el backend
        return fetchData(URL_BKI.TRACES, {
          method: "POST",
          data: filtrosConServei,
          config: {
            headers: {
              "Content-Type": APP_JSON,
              Accept: APP_JSON,
            },
          },
        });
      });

      const resultados = await Promise.all(peticiones);
      // Combina los datos de todas las respuestas
      const dataCombinada = resultados.flatMap(r => r.data || []);
      // Si alguna petición tuvo error, muestra el primero
      const errorObj = resultados.find(r => r.error);
      const error = errorObj ? errorObj.error : undefined;
      if (error) {
        console.error(`Ha ocurrido un error al pedir el recurso. Error: ${error.message}`);
        setLoading(false);
      }
      setData(dataCombinada);
      setLoading(false);
      return;
    }

    // Si no hay filtro de App, petición normal
    const { data, error } = await fetchData(URL_BKI.TRACES, {
      method: "POST",
      data: filters,
      config: {
        headers: {
          "Content-Type": APP_JSON,
          Accept: APP_JSON,
        },
      },
    });

    if (error) {
      console.error(`Ha ocurrido un error al pedir el recurso. Error: ${error.message}`);
      setLoading(false);
    }

    setData(data);
    setLoading(false);
  };

 /* useEffect(() => {
    fetchTraces();
  }, []);*/

  useEffect(() => {
    if (selectedRow) {
      fetchTrace(selectedRow);
    }
  }, [selectedRow]);

  const submitFilters = (event) => {
    event.preventDefault();
    console.log(filters)

    fetchTraces();
  };

  function modalWithDetailTrace() {
    const shoudlRenderDetailTrace = selectedRow && dataTraza;
    if (!shoudlRenderDetailTrace) {
      return null;
    }

    const params = dataTraza.params;
    const hasParams = params && params.length > 0;

    return (
      <>
        <Modal
          sx={{
            width: "80%",
            margin: "150px auto",
          }}
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={hasParams ? styleModal : styleModalSenseResultats}>
            {hasParams ? (
              <>
                <DataGridBkitb
                  getRowHeight={() => "auto"}
                  data={params}
                  heightTaula="500px"
                  ampleTaula="90%"
                  marginTaula="0 auto"
                  density="comfortable"
                  rowHeight={60}
                  checkboxSelection={false}
                  col={columnsTrazabilidad}
                  rowId={(row) => row.idParam}
                  components={{ Toolbar: ToolbarLogsEnviaments }}
                  loading={loading}
                />
              </>
            ) : (
              <MsgResultatQuery data={params.length} idTraza={selectedRow} />
            )}
            <div style={{ marginTop: "50px" }}>
              <Button
                variant="contained"
                startIcon={<UndoIcon />}
                onClick={handleClose}
                color="inherit"
              >
                Tornar
              </Button>
            </div>
          </Box>
        </Modal>
      </>
    );
  }

  const updateRowReintents = (trazaId, newReintents) => {
    setData(prevData =>
      prevData.map(row =>
        row.id === trazaId ? { ...row, reintents: newReintents } : row
      )
    );
  };

  function renderTable() {
    // Mapeo de campos para que coincidan con las columnas
    const dataMapped = data.map((row, idx) => ({
      ...row,
      id: row.id ? row.id : idx,
      TRAS_ID_AUTO: row.id,
      TRAS_SERVEI: row.servei,
      TRAS_MODALITAT: row.modalitat,
      TRAS_ESTAT: row.estat,
      TRAS_ESTAT_DOCTRAM: row.estatDoctram,
      TRAS_ESTAT_TERCER: row.estatTercers,
      TRAS_REINTENTS: row.reintents,
      TRAS_DATA_EXEC: row.dataExec,
      TRAS_TEMPS_TRANSCORREGUT: row.tempsTranscorregut,
      TRAS_DESC_ERR: row.descErr,
      TRAS_DADES_PETICIO: row.dadesPeticio,
      TRAS_DADES_RETORN: row.dadesRetorn,
      TRAS_REINICIAR_REINTENTS: row.reiniciarReintents,
      onReintentsReset: updateRowReintents
    }));

    return (
      <DataGridBkitb
        data={dataMapped}
        rawData={data}
        ampleTaula="100%"
        density="compact"
        // sortModel={[
        //   {
        //     field: "TRAS_ID_AUTO",
        //     sort: "DESC",
        //   },
        // ]}
        rowHeight={80}
        checkboxSelection={true}
        col={columnsTraceServeis}
        rowId={(row) => row.id}
        components={{ Toolbar: ToolbarLogsEnviaments }}
        selectionModel={selectionModel}
        onSelectionModelChange={(selection) => {
          if (selection.length > 0) {
            setSelectionModel([selection[selection.length - 1]]);

            handleOpen(); //abrimos modal
            setSelectedRow(selection[selection.length - 1]);
          } else {
            setSelectionModel([]);
            setSelectedRow(0);
          }
        }}
        loading={loading}
      />
    );
  }

const reprocessDocumentsDOCTRAM = async (event) => {
  event.preventDefault();

  setLoading(true);

  const { error } = await fetchData(URL_BKINT_TRAM.REPROCESS_DOCUMENTS_DOCTRAM, {
    method: "POST",
    data: null,
    config: {
      headers: {
        "Content-Type": APP_JSON,
        Accept: APP_JSON,
      },
    },
  });

  if (error) {
    console.error(`Ha ocurrido un error al pedir el recurso. Error: ${error.message}`);
    setLoading(false);
    ErrorAlert(`Ha ocurrido un error al pedir el recurso. Error: ${error.message}`);
  }

  fetchTraces();

  setLoading(false);
};

function renderActionsSection(){
  return (
    <Grid item xs={4}>
      <Button
      onClick={reprocessDocumentsDOCTRAM}
      type="button"
      variant="contained"
      color="secondary"
    >
      {"Reprocessa Documents DOCTRAM"}
    </Button>
  </Grid>
  )
}

  return (
    <Container
      maxWidth="xl"
      sx={{ marginBottom: 5 }}
      className="w-100, boxPantalla"
    >
      <h2>Taula de traçabilitat </h2>
      <Stack>
        <TraceFilterBox submitFilters={submitFilters}></TraceFilterBox>
      </Stack>
      {renderTable()}
      {modalWithDetailTrace()}

      <Paper elevation={4} sx={{ boxShadow: "1px 2px 6px rgba(0, 0, 0, 0.46)", paddingBottom: "20px" }}>
        <Box>
        <Grid container direction={"row"} spacing={2} alignItems={"center"}>
           <Grid item xs={12}>
              <Typography variant="h5" fontWeight={"bold"}>Accions extra</Typography>
           </Grid>
            {renderActionsSection()}
        </Grid>
        </Box>
      </Paper>
    </Container>
  );
}
export default Trazabilidad;
